export const desktopHelpCenterLink =
  "https://help.justworks.com/hc/en-us/articles/17024877999515-Expenses-Desktop-";

export const submitterDesktopHelpCenterLink =
  "https://help.justworks.com/hc/en-us/articles/17042398631323-Expense-Submissions-for-Employees-Desktop-";
